import { GET } from '../config'

import {
  IQuestionResponse,
  ICommonListResponse,
  ICauseResponse,
  ISignatoryPayload,
  IReportFiltersResponse,
} from '../../../interfaces/static.interface'

export interface ICommonAPI {
  fetchBaseOfAssignment: () => Promise<ICommonListResponse>
  fetchCause: () => Promise<ICauseResponse>
  fetchCompany: () => Promise<ICommonListResponse>
  fetchDepartment: () => Promise<ICommonListResponse>
  fetchQuestions: () => Promise<IQuestionResponse>
  fetchReason: () => Promise<ICommonListResponse>
  fetchReportFilters: () => Promise<IReportFiltersResponse>
  fetchSignatory: (params: ISignatoryPayload) => Promise<ICommonListResponse>
}

export default {
  fetchBaseOfAssignment: (): Promise<ICommonListResponse> => {
    return GET('/api/v1/static/base-of-assignment/').then((res) => res.data)
  },

  fetchCause: (): Promise<ICauseResponse> => {
    return GET('/api/v1/static/cause/').then((res) => res.data)
  },

  fetchCompany: (): Promise<ICommonListResponse> => {
    return GET('/api/v1/static/company/').then((res) => res.data)
  },

  fetchDepartment: (): Promise<ICommonListResponse> => {
    return GET('/api/v1/static/department/').then((res) => res.data)
  },

  fetchQuestions: (): Promise<IQuestionResponse> => {
    return GET('/api/v1/static/question/').then((res) => res.data)
  },

  fetchReason: (): Promise<ICommonListResponse> => {
    return GET('/api/v1/static/reason-resignation/').then((res) => res.data)
  },

  fetchReportFilters: (): Promise<IReportFiltersResponse> => {
    return GET('/api/v1/static/report/').then((res) => res.data)
  },

  fetchSignatory: (params: ISignatoryPayload): Promise<ICommonListResponse> => {
    return GET('/api/v1/static/signatories/', { params }).then((res) => res.data)
  },
}
